import { createFileRoute } from '@tanstack/react-router';
import { RecurrencePage } from '#features/recurrence/recurrence-page';

export const Route = createFileRoute('/_authed/repeating')({ component: RecurrencePage });
